import type { Variant } from '../components/tag'

export const getIconVariantColor = (variant: Variant) => {
  switch (variant) {
    case 'success':
      return 'success'

    case 'warning':
      return 'warning'

    case 'error':
      return 'error'

    case 'highlight':
      return 'primary'

    case 'default':
    default:
      return 'gray'
  }
}
